import { List } from 'antd';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import { Menu } from 'components/atoms/dropdown';
import { ProductiveCompact01 } from 'components/styles';

export const Header = styled(Menu.Header)`
  margin-top: var(--spacing-05);
`;

export const StyledMenu = styled.div`
  overflow-x: hidden;
  position: relative;
`;

export const FooterContent = styled.div`
  background-color: var(--white-100);
  width: 100%;
  border-top: 1px solid var(--border-color);
  padding: var(--spacing-04) var(--spacing-05);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledCheckbox = styled(Checkbox)`
  line-height: var(--font-size-base);
  padding-right: var(--spacing-03);
`;

export const CustomMenuItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--height-lg);
  padding: var(--spacing-03);
  cursor: pointer;
  box-shadow: var(--shadow-02);
  &:hover {
    background: var(--item-hover-bg);
  }
`;

export const ListContentCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  &:last-child {
    border-left: 1px solid var(--border-color);
  }
`;

export const ListContainer = styled(List)`
  flex: 1;
  .ant-list-item {
    padding: var(--spacing-03) 0;
  }
`;

export const NoResultMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: var(--gray-50);
  padding: var(--spacing-08);
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  .column-move-to-top {
    opacity: 0;
  }
  &:hover {
    .column-move-to-top {
      opacity: 1;
    }
  }
`;

export const ListContent = styled.div`
  display: flex;
`;

export const ListHeader = styled.strong`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: var(--spacing-05) var(--spacing-05);
  ${ProductiveCompact01};
`;

export const ListItemName = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
`;
